import { render } from "./PendulumExperiment.vue?vue&type=template&id=1e22a0ba&scoped=true"
import script from "./PendulumExperiment.vue?vue&type=script&lang=js"
export * from "./PendulumExperiment.vue?vue&type=script&lang=js"

import "./PendulumExperiment.vue?vue&type=style&index=0&id=1e22a0ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e22a0ba"]])

export default __exports__